export default "__VITE_ASSET__Cw2xbhfh__"